import {axiosInstance} from './axios';

export async function getUniversity(id) {
  console.log('sss')
  try {
    return await axiosInstance.get(`/api/v1/university/${id}`)
  }catch (e) {
    return null;
  }
}

export async function editUniversityApi(id,data) {
  console.log('sss')
  try {
    return await axiosInstance.put(`/api/v1/university/${id}`,data)
  }catch (e) {
    return null;
  }
}
